import api from './api';
import { Response, Template } from '../dtos';

const findAllTemplates = async (): Promise<Template[]> => {
    const { data } = await api.get<Response<Template[]>>('templates');

    return data.data;
};

export { findAllTemplates };